module.exports = __webpack_public_path__ + "static/media/10.12ba61e4.jpg";